import React, { useEffect, useState } from "react";
import { Typography, IconButton, Stack, Box, Grid } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PatientCard from "./PatientCard";
import {
  fetchPatientAndRelatives,
} from "../services/patientRegistrationRequesApi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  getTokenClinicDoctor,
  getValueFromPatToken,
} from "../utils/commonUtils";
import { usePatientContext } from "../context/PatientContext";

const FamilyList = () => {
  const { patientAppData, getPatientAppData } =
    usePatientContext();

  const location = useLocation();
  const history = useNavigate();
  
  const { ...restStateData } = location?.state ?? {};

  const [patientsList, setPatientsList] = useState([]);
  const [clinicId, setClinicId] = useState();
  const [doctorId, setDoctorId] = useState(null);
  const [userId, setUserId] = useState();
  const [showWelcomeText, setShowWelcomeText] = useState(false);
  const [selectedDr, setSelectedDr] = useState('');

  const [showDetails, setShowDetails] = React.useState(
    Array(patientsList?.length).fill(false)
  );


  useEffect(() => {
    const getClinicAndDoctor = getTokenClinicDoctor();

    setClinicId(getClinicAndDoctor.clinicId);
    setDoctorId(getClinicAndDoctor.doctorId);
    let userIdget = getValueFromPatToken("user_id");
    setUserId(userIdget);
    GetDrNameFromToken()
  }, []);

  useEffect(() => {
    if (clinicId && doctorId) {
      setShowWelcomeText(true);
    }
  }, [clinicId, doctorId]);

  const toggleDetails = (index) => {
    setShowDetails((prevShowDetails) => {
      const newShowDetails = [...prevShowDetails];
      newShowDetails[index] = !newShowDetails[index];
      return newShowDetails;
    });
  };

  const GetDrNameFromToken=()=>{
    const patClinicDoctor = localStorage.getItem('pat-clinic-doctor');
    if (patClinicDoctor) {
      try {
        const { doctorName } = JSON.parse(patClinicDoctor);
        setSelectedDr(doctorName); 
      } catch (error) {
        console.error('Error parsing JSON from localStorage:', error);
      }
    } else {
      console.error('No data found in localStorage for pat-clinic-doctor');
    }
  }

  const fetchPatients = async () => {
    try {
      const response = await fetchPatientAndRelatives(userId);
      const list = [
        response?.data?.patientInfo.patient,
        ...response?.data?.relatedPatientsInfo.relatedPatients,
      ].filter(Boolean);
      setPatientsList(list);
      if (list.length == 0) {
        history("/patient/familylist/add", {
          state: {
            clinicIdProps: clinicId,
            doctorIdProps: doctorId,
            memberAdd: false,
            relativePatId: 0,
            ...restStateData,
          },
        });
      }
      // setShowRegistrationForm(list.length === 0);
    } catch (error) {
      console.error("Error fetching patients:", error);
    }
  };
  
  useEffect(() => {
    if (userId != undefined) {
      fetchPatients();
    }
  }, [userId]);

  const generateRandomColor = () => {
    return "#" + Math.floor(Math.random() * 16777215).toString(16);
  };

  return (
    <Box className=" bg-gradient-to-b from-[#e8f0fb] from-[2%] via-white via-[50%]   to-[#fff] to-[48%]  min-h-[calc(100vh-72px)] w-full p-4 pt-10 pb-20">
      {showWelcomeText && (
        <Stack
          spacing={2}
          direction="column"
          alignItems="center"
          justifyContent="center"
          sx={{ width: "100%", mb: 2 }}
        >
          <Typography
            variant="h5"
            gutterBottom
            fontWeight="bold"
            textAlign="center"
            color="#2C3E50"
          >
            Welcome to the {patientAppData?.clinicDetails?.clinicName || ""}
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            fontWeight="medium"
            textAlign="center"
            color="#2C3E50"
          >
            You are booking an appointment forget Dr.
            <span className=" font-semibold">
              {selectedDr}
            </span>{" "}
            for today
          </Typography>
          <Typography
            variant="subtitle1"
            gutterBottom
            fontWeight="medium"
            textAlign="center"
            color="#2C3E50"
          >
            Please select the Patient
          </Typography>
        </Stack>
      )}

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ width: "100%", mb: 2 }}
      >
        <Typography variant="h5" fontWeight="bold" color="#2C3E50">
          My Family
        </Typography>
        <Link
          to={"/patient/familylist/add"}
          state={{
            ...restStateData,
            clinicIdProps: clinicId,
            doctorIdProps: doctorId,
            memberAdd: patientsList.length > 0,
            relativePatId:
              patientsList.length > 0 ? patientsList[0].patient_id : 0,
          }}
        >
          <IconButton
            // onClick={handleAddMemberClick}
            color="primary"
            size="large"
          >
            <AddCircleOutlineIcon />
          </IconButton>
        </Link>
      </Stack>

      <div className=" w-full grid gap-x-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4  2xl:grid-cols-4">
        {patientsList
          .slice() // Create a shallow copy of the array to avoid mutating the original array
          .sort((a, b) =>
            a.userDetails.first_name.localeCompare(b.userDetails.first_name)
          ) // Sort the array alphabetically by first_name
          .map((patient, index) => {
            const avatarColor = generateRandomColor(); // Generate random color for each iteration
            return (
              <div className=" w-full">
                <PatientCard
                  key={patient.id}
                  patient={patient}
                  index={index}
                  showDetails={showDetails}
                  toggleDetails={toggleDetails}
                  avatarColor={avatarColor}
                />
              </div>
            );
          })}
      </div>
    </Box>
  );
};

export default FamilyList;
